import { render, staticRenderFns } from "./admin-content.vue?vue&type=template&id=e4304f68&scoped=true"
import script from "./admin-content.vue?vue&type=script&lang=ts"
export * from "./admin-content.vue?vue&type=script&lang=ts"
import style0 from "./admin-content.vue?vue&type=style&index=0&id=e4304f68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4304f68",
  null
  
)

export default component.exports